import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import PresentationInsertModal from "../PresentationInsertModal";

import { getAllProject } from "../../../reducer/project/action";
import {
  getAllPresentation,
  getAllPresentationByProfileId,
  getFilteredPresentation,
} from "../../../reducer/presentation/action";

function PresentationButton(props) {
  const { getAllPresentation, getAllPresentationByProfileId, getFilteredPresentation } = props;

  const [inserting, setInserting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllPresentationByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredPresentation.length === 0 && !props.isFetching)
      getFilteredPresentation(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredPresentation(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredPresentation]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllPresentationByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredPresentation(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Bài trình bày, truyền thông, phỏng vấn, truyền hình
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <PresentationInsertModal inserting={inserting} setInserting={setInserting} />
    </>
  );
}

const mapStateToProps = (state) => ({
  // isFetching: select(state, 'projectReducer', 'isFetching'),
  // isFetchingAccepted: select(state, 'projectReducer', 'isFetchingAccepted'),

  profileDetail: select(state, "profileReducer", "detail"),
  listPresentationById: select(state, "presentationReducer", "listById"),
  listFilteredPresentation: select(state, "presentationReducer", "listFiltered"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllPresentationByProfileId: (id) => dispatch(getAllPresentationByProfileId(id)),
  getFilteredPresentation: (page, pageSize, payload) => dispatch(getFilteredPresentation(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PresentationButton));

